import { useLocation, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';

export default function CustomNavigate({ to, params = {}, replace = false }) {
	const location = useLocation();

	// Support callers passing a query string inside `to` (pathname must not contain '?')
	const [pathname, toSearch] = to.split('?');

	const currentParams = new URLSearchParams(location.search);
	for (const [key, value] of new URLSearchParams(toSearch)) {
		currentParams.set(key, value);
	}

	for (const key in params) {
		if (params[key] !== undefined && params[key] !== null) {
			currentParams.set(key, params[key]);
		}
	}

	const finalTo = {
		pathname,
		search: currentParams.toString() ? `?${currentParams.toString()}` : ''
	};
	return <Navigate to={finalTo} replace={replace} />;
}

CustomNavigate.propTypes = {
	to: PropTypes.string.isRequired,
	params: PropTypes.object,
	replace: PropTypes.bool
};
